import { createConfig, http } from "wagmi";
import { polygonAmoy } from "wagmi/chains";
import { injected, walletConnect, coinbaseWallet } from "wagmi/connectors";

export const walletConnectProjectId =
  import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || "";

const appName = "Orion";
const appDescription = "Orion prediction market app";

export const wagmiConfig = createConfig({
  chains: [polygonAmoy],
  connectors: [
    injected({
      shimDisconnect: true,
    }),

    coinbaseWallet({
      appName,
      preference: "all",
    }),

    ...(walletConnectProjectId
      ? [
          walletConnect({
            projectId: walletConnectProjectId,
            showQrModal: true,
            metadata: {
              name: appName,
              description: appDescription,
              url: window.location.origin,
              icons: [`${window.location.origin}/favicon.ico`],
            },
          }),
        ]
      : []),
  ],
  transports: {
    [polygonAmoy.id]: http("https://rpc-amoy.polygon.technology"),
  },
});
